import script from "./PaymentSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentSelect.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentSelect.vue?vue&type=style&index=0&id=52ed0c7e&lang=scss"

const __exports__ = script;

export default __exports__